import { COLORS } from '@btime/constants'
import React from 'react'

import { RingProgress } from '@ant-design/plots'

import { useColor } from '../../../../../../packages/kiti/components/theme/_hooks/colors'

const ProgressChart = ({ color, presentation, value, all }) => {
  color = useColor(color)

  if (presentation !== 'circle') return false
  const percent = value / all
  if (isNaN(percent)) return false

  const config = {
    height: 75,
    width: 75,
    autoFit: false,
    percent,
    color: [color, COLORS.light2]
  }

  return <RingProgress {...config} />
}

export default ProgressChart
